import { withStyles } from '@material-ui/styles'
import { Grid } from '@material-ui/core'

const height = '100%'
const GridFullHeight = withStyles(_theme => ({ root: { height } }))(Grid)

export default GridFullHeight
export const createGridFullHeightWithPaddingBottom = paddingBottom => withStyles(_theme => ({ root: { height, paddingBottom } }))(Grid)
